import { useAudio } from '../../contexts/AudioContext';
import { IoPlaySkipForward } from 'react-icons/io5';
import './PlayNextButton.css'; 

// This component is a button that plays the next clip in the queue
// If the queue is empty, the button will be disabled
export function PlayNextButton({ size = "40px", color = "#D9D9D9" }) {
    const { playNextClip, queue, autoqueue } = useAudio();

    const isDisabled = queue.length <= 0 && autoqueue.length <= 0;

    const handleClick = () => {
        if (isDisabled) return; // Early return if button is disabled
        playNextClip();
    };

    return (
        <button
            onClick={handleClick}
            className={`playNextButton ${isDisabled ? 'disabled' : ''}`}
            disabled={isDisabled} 
        >
            <IoPlaySkipForward color={color} size={size} />
        </button>
    );
}
